import { useIntl } from 'react-intl'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import styled from 'styled-components'

export default function ErrorElement(): JSX.Element {
  const error = useRouteError()
  const intl = useIntl()

  let errorMessage: string

  if (isRouteErrorResponse(error)) {
    errorMessage = error.data?.message || error.statusText
  } else if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  } else {
    console.error(error)
    errorMessage = 'Unknown error'
  }

  return (
    <ErrorContainer>
      <h1>{intl.formatMessage({ id: 'strings.error' })}</h1>
      <pre>{errorMessage}</pre>
    </ErrorContainer>
  )
}

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 50px 0;
  background-color: ${(props) => props.theme.customPalette.light};
  overflow: hidden;

  & h1 {
    color: ${(props) => props.theme.palette.primary.main};
    font-size: 30px;
  }

  & p {
    margin: 30px 0;
  }

  & span {
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
  }

  & pre {
    width: 50%;
    margin-top: 30px;
    padding: 30px;
    background-color: ${(props) => props.theme.customPalette.lightGray};
    font-size: 12px;
  }
`
